// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("reactions.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("reactions.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("reactions.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("reactions.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'reactions';
  src:  url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src:  url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('svg');
  font-weight: normal;
  font-style: normal;
  font-display: block;
}

[class^="iconr-"], [class*=" iconr-"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'reactions' !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.iconr-clap .path1:before {
  content: "\\e900";
  color: rgb(49, 137, 72);
}
.iconr-clap .path2:before {
  content: "\\e901";
  margin-left: -1em;
  
}
.iconr-clap .path3:before {
  content: "\\e902";
  margin-left: -1em;
  
}
.iconr-clap .path4:before {
  content: "\\e903";
  margin-left: -1em;
 
}
.iconr-clap .path5:before {
  content: "\\e904";
  margin-left: -1em;
 
}
.iconr-clap .path6:before {
  content: "\\e905";
  margin-left: -1em;
 
}
.iconr-clap .path7:before {
  content: "\\e906";
  margin-left: -1em;
  color: rgb(0, 194, 86);
}
.iconr-clap .path8:before {
  content: "\\e907";
  margin-left: -1em;
 
}
.iconr-clap .path9:before {
  content: "\\e908";
  margin-left: -1em;
  color: rgb(77, 84, 81);
}
.iconr-clap .path10:before {
  content: "\\e909";
  margin-left: -1em;
  
}
.iconr-clap .path11:before {
  content: "\\e90a";
  margin-left: -1em;
  color: rgb(77, 84, 81);
}
.iconr-clap .path12:before {
  content: "\\e90b";
  margin-left: -1em;
  
}
.iconr-clap .path13:before {
  content: "\\e90c";
  margin-left: -1em;
  
}
.iconr-clap .path14:before {
  content: "\\e90d";
  margin-left: -1em;
 
}
.iconr-clap .path15:before {
  content: "\\e90e";
  margin-left: -1em;
  
}
.iconr-clap .path16:before {
  content: "\\e90f";
  margin-left: -1em;
 
}
.iconr-clap .path17:before {
  content: "\\e910";
  margin-left: -1em;
  color: rgb(77, 84, 81);
}
.iconr-clap .path18:before {
  content: "\\e911";
  margin-left: -1em;
  color: none;
}
.iconr-clap .path19:before {
  content: "\\e912";
  margin-left: -1em;
  
}
.iconr-clap .path20:before {
  content: "\\e913";
  margin-left: -1em;
  
}
.iconr-clap .path21:before {
  content: "\\e914";
  margin-left: -1em;
 
}
.iconr-clap .path22:before {
  content: "\\e915";
  margin-left: -1em;
  
}
.iconr-clap .path23:before {
  content: "\\e916";
  margin-left: -1em;
  
}
.iconr-clap .path24:before {
  content: "\\e917";
  margin-left: -1em;
 
}
.iconr-clap .path25:before {
  content: "\\e918";
  margin-left: -1em;
}
.iconr-clap .path26:before {
  content: "\\e919";
  margin-left: -1em;
}
.iconr-clap .path27:before {
  content: "\\e91a";
  margin-left: -1em;
}
.iconr-clap .path28:before {
  content: "\\e91b";
  margin-left: -1em;
}
.iconr-red-card .path1:before {
  content: "\\e91c";
  color: rgb(184, 156, 20);
}
.iconr-red-card .path2:before {
  content: "\\e91d";
  margin-left: -1em;
  color: rgb(255, 215, 22);
}
.iconr-red-card .path3:before {
  content: "\\e91e";
  margin-left: -1em;
  color: rgb(235, 59, 59);
}
.iconr-red-card .path4:before {
  content: "\\e91f";
  margin-left: -1em;
  color: rgb(255, 215, 22);
}
.iconr-red-card .path5:before {
  content: "\\e920";
  margin-left: -1em;
  color: rgb(208, 38, 38);
}
.iconr-red-card .path6:before {
  content: "\\e921";
  margin-left: -1em;
  color: rgb(255, 215, 22);
}
.iconr-red-card .path7:before {
  content: "\\e922";
  margin-left: -1em;
  color: rgb(255, 215, 22);
}
.iconr-red-card .path8:before {
  content: "\\e923";
  margin-left: -1em;
  color: rgb(208, 38, 38);
}
.iconr-red-card .path9:before {
  content: "\\e924";
  margin-left: -1em;
  color: rgb(152, 55, 53);
}
.iconr-red-card .path10:before {
  content: "\\e925";
  margin-left: -1em;
  color: rgb(184, 156, 20);
}
.iconr-red-card .path11:before {
  content: "\\e926";
  margin-left: -1em;
  color: rgb(184, 156, 20);
}
.iconr-red-card .path12:before {
  content: "\\e927";
  margin-left: -1em;
  color: rgb(152, 55, 53);
}
.iconr-celebrate .path1:before {
  content: "\\e928";
  color: rgb(253, 211, 3);
}
.iconr-celebrate .path2:before {
  content: "\\e929";
  margin-left: -1em;
  color: rgb(0, 194, 86);
}
.iconr-celebrate .path3:before {
  content: "\\e92a";
  margin-left: -1em;
  color: rgb(0, 194, 86);
}
.iconr-celebrate .path4:before {
  content: "\\e92b";
  margin-left: -1em;
  color: rgb(248, 197, 1);
}
.iconr-celebrate .path5:before {
  content: "\\e92c";
  margin-left: -1em;
  color: rgb(49, 137, 72);
}
.iconr-celebrate .path6:before {
  content: "\\e92d";
  margin-left: -1em;
  color: rgb(248, 197, 1);
}
.iconr-celebrate .path7:before {
  content: "\\e92e";
  margin-left: -1em;
  color: rgb(0, 194, 86);
}
.iconr-celebrate .path8:before {
  content: "\\e92f";
  margin-left: -1em;
  color: rgb(253, 211, 3);
}
.iconr-celebrate .path9:before {
  content: "\\e930";
  margin-left: -1em;
  color: rgb(49, 137, 72);
}
.iconr-celebrate .path10:before {
  content: "\\e931";
  margin-left: -1em;
  color: rgb(49, 137, 72);
}
.iconr-celebrate .path11:before {
  content: "\\e932";
  margin-left: -1em;
  color: rgb(2, 86, 162);
}
.iconr-celebrate .path12:before {
  content: "\\e933";
  margin-left: -1em;
  color: none;
}
.iconr-celebrate .path13:before {
  content: "\\e934";
  margin-left: -1em;
  color: none;
}
.iconr-celebrate .path14:before {
  content: "\\e935";
  margin-left: -1em;
  color: none;
}
.iconr-support .path1:before {
  content: "\\e936";
  color: rgb(241, 228, 63);
}
.iconr-support .path2:before {
  content: "\\e937";
  margin-left: -1em;
  color: rgb(241, 228, 63);
  opacity: 0.2;
}
.iconr-support .path3:before {
  content: "\\e938";
  margin-left: -1em;
  color: rgb(184, 156, 20);
  opacity: 0.2;
}
.iconr-support .path4:before {
  content: "\\e939";
  margin-left: -1em;
  color: rgb(184, 156, 20);
  opacity: 0.2;
}
.iconr-support .path5:before {
  content: "\\e93a";
  margin-left: -1em;
  color: rgb(184, 156, 20);
  opacity: 0.2;
}
.iconr-support .path6:before {
  content: "\\e93b";
  margin-left: -1em;
  color: rgb(184, 156, 20);
  opacity: 0.2;
}
.iconr-support .path7:before {
  content: "\\e93c";
  margin-left: -1em;
  color: rgb(255, 215, 22);
  opacity: 0.5;
}
.iconr-support .path8:before {
  content: "\\e93d";
  margin-left: -1em;
  color: rgb(184, 156, 20);
  opacity: 0.2;
}
.iconr-sad .path1:before {
  content: "\\e93e";
  color: rgb(241, 228, 63);
}
.iconr-sad .path2:before {
  content: "\\e93f";
  margin-left: -1em;
  color: rgb(241, 228, 63);
  opacity: 0.2;
}
.iconr-sad .path3:before {
  content: "\\e940";
  margin-left: -1em;
  color: rgb(241, 228, 63);
  opacity: 0.2;
}
.iconr-sad .path4:before {
  content: "\\e941";
  margin-left: -1em;
  color: rgb(241, 228, 63);
  opacity: 0.3;
}
.iconr-sad .path5:before {
  content: "\\e942";
  margin-left: -1em;
  color: rgb(77, 84, 81);
}
.iconr-sad .path6:before {
  content: "\\e943";
  margin-left: -1em;
  color: rgb(77, 84, 81);
  opacity: 0.76;
}
.iconr-sad .path7:before {
  content: "\\e944";
  margin-left: -1em;
  color: rgb(77, 84, 81);
}
.iconr-sad .path8:before {
  content: "\\e945";
  margin-left: -1em;
  color: rgb(77, 84, 81);
}
.iconr-sad .path9:before {
  content: "\\e946";
  margin-left: -1em;
  color: rgb(77, 84, 81);
}
.iconr-sad .path10:before {
  content: "\\e947";
  margin-left: -1em;
  color: rgb(77, 84, 81);
}
.iconr-sad .path11:before {
  content: "\\e948";
  margin-left: -1em;
  color: rgb(111, 203, 217);
}
.iconr-sad .path12:before {
  content: "\\e949";
  margin-left: -1em;
  color: rgb(77, 84, 81);
}
.iconr-sad .path13:before {
  content: "\\e94a";
  margin-left: -1em;
  color: rgb(77, 84, 81);
}
.iconr-sad .path14:before {
  content: "\\e94b";
  margin-left: -1em;
  color: rgb(111, 203, 217);
}
.iconr-funny .path1:before {
  content: "\\e94c";
  color: rgb(241, 228, 63);
}
.iconr-funny .path2:before {
  content: "\\e94d";
  margin-left: -1em;
  color: rgb(241, 228, 63);
  opacity: 0.2;
}
.iconr-funny .path3:before {
  content: "\\e94e";
  margin-left: -1em;
  color: rgb(241, 228, 63);
  opacity: 0.2;
}
.iconr-funny .path4:before {
  content: "\\e94f";
  margin-left: -1em;
  color: rgb(241, 228, 63);
  opacity: 0.3;
}
.iconr-funny .path5:before {
  content: "\\e950";
  margin-left: -1em;
  color: rgb(77, 84, 81);
}
.iconr-funny .path6:before {
  content: "\\e951";
  margin-left: -1em;
  color: none;
}
.iconr-funny .path7:before {
  content: "\\e952";
  margin-left: -1em;
  color: none;
}
.iconr-funny .path8:before {
  content: "\\e953";
  margin-left: -1em;
  color: rgb(255, 255, 255);
}
.iconr-funny .path9:before {
  content: "\\e954";
  margin-left: -1em;
  color: rgb(77, 84, 81);
}
.iconr-funny .path10:before {
  content: "\\e955";
  margin-left: -1em;
  color: rgb(77, 84, 81);
}
.iconr-funny .path11:before {
  content: "\\e956";
  margin-left: -1em;
  color: rgb(111, 203, 217);
}
.iconr-funny .path12:before {
  content: "\\e957";
  margin-left: -1em;
  color: rgb(111, 203, 217);
}
.iconr-funny .path13:before {
  content: "\\e958";
  margin-left: -1em;
  color: rgb(111, 203, 217);
}
.iconr-funny .path14:before {
  content: "\\e959";
  margin-left: -1em;
  color: rgb(111, 203, 217);
}
`, "",{"version":3,"sources":["webpack://./src/assets/fonts/reactions.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,6CAA0B;EAC1B;;;yDAGoC;EACpC,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,+EAA+E;EAC/E,mCAAmC;EACnC,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;;EAEd,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B","sourcesContent":["@font-face {\n  font-family: 'reactions';\n  src:  url('reactions.eot');\n  src:  url('reactions.eot') format('embedded-opentype'),\n    url('reactions.ttf') format('truetype'),\n    url('reactions.woff') format('woff'),\n    url('reactions.svg') format('svg');\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n[class^=\"iconr-\"], [class*=\" iconr-\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'reactions' !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.iconr-clap .path1:before {\n  content: \"\\e900\";\n  color: rgb(49, 137, 72);\n}\n.iconr-clap .path2:before {\n  content: \"\\e901\";\n  margin-left: -1em;\n  \n}\n.iconr-clap .path3:before {\n  content: \"\\e902\";\n  margin-left: -1em;\n  \n}\n.iconr-clap .path4:before {\n  content: \"\\e903\";\n  margin-left: -1em;\n \n}\n.iconr-clap .path5:before {\n  content: \"\\e904\";\n  margin-left: -1em;\n \n}\n.iconr-clap .path6:before {\n  content: \"\\e905\";\n  margin-left: -1em;\n \n}\n.iconr-clap .path7:before {\n  content: \"\\e906\";\n  margin-left: -1em;\n  color: rgb(0, 194, 86);\n}\n.iconr-clap .path8:before {\n  content: \"\\e907\";\n  margin-left: -1em;\n \n}\n.iconr-clap .path9:before {\n  content: \"\\e908\";\n  margin-left: -1em;\n  color: rgb(77, 84, 81);\n}\n.iconr-clap .path10:before {\n  content: \"\\e909\";\n  margin-left: -1em;\n  \n}\n.iconr-clap .path11:before {\n  content: \"\\e90a\";\n  margin-left: -1em;\n  color: rgb(77, 84, 81);\n}\n.iconr-clap .path12:before {\n  content: \"\\e90b\";\n  margin-left: -1em;\n  \n}\n.iconr-clap .path13:before {\n  content: \"\\e90c\";\n  margin-left: -1em;\n  \n}\n.iconr-clap .path14:before {\n  content: \"\\e90d\";\n  margin-left: -1em;\n \n}\n.iconr-clap .path15:before {\n  content: \"\\e90e\";\n  margin-left: -1em;\n  \n}\n.iconr-clap .path16:before {\n  content: \"\\e90f\";\n  margin-left: -1em;\n \n}\n.iconr-clap .path17:before {\n  content: \"\\e910\";\n  margin-left: -1em;\n  color: rgb(77, 84, 81);\n}\n.iconr-clap .path18:before {\n  content: \"\\e911\";\n  margin-left: -1em;\n  color: none;\n}\n.iconr-clap .path19:before {\n  content: \"\\e912\";\n  margin-left: -1em;\n  \n}\n.iconr-clap .path20:before {\n  content: \"\\e913\";\n  margin-left: -1em;\n  \n}\n.iconr-clap .path21:before {\n  content: \"\\e914\";\n  margin-left: -1em;\n \n}\n.iconr-clap .path22:before {\n  content: \"\\e915\";\n  margin-left: -1em;\n  \n}\n.iconr-clap .path23:before {\n  content: \"\\e916\";\n  margin-left: -1em;\n  \n}\n.iconr-clap .path24:before {\n  content: \"\\e917\";\n  margin-left: -1em;\n \n}\n.iconr-clap .path25:before {\n  content: \"\\e918\";\n  margin-left: -1em;\n}\n.iconr-clap .path26:before {\n  content: \"\\e919\";\n  margin-left: -1em;\n}\n.iconr-clap .path27:before {\n  content: \"\\e91a\";\n  margin-left: -1em;\n}\n.iconr-clap .path28:before {\n  content: \"\\e91b\";\n  margin-left: -1em;\n}\n.iconr-red-card .path1:before {\n  content: \"\\e91c\";\n  color: rgb(184, 156, 20);\n}\n.iconr-red-card .path2:before {\n  content: \"\\e91d\";\n  margin-left: -1em;\n  color: rgb(255, 215, 22);\n}\n.iconr-red-card .path3:before {\n  content: \"\\e91e\";\n  margin-left: -1em;\n  color: rgb(235, 59, 59);\n}\n.iconr-red-card .path4:before {\n  content: \"\\e91f\";\n  margin-left: -1em;\n  color: rgb(255, 215, 22);\n}\n.iconr-red-card .path5:before {\n  content: \"\\e920\";\n  margin-left: -1em;\n  color: rgb(208, 38, 38);\n}\n.iconr-red-card .path6:before {\n  content: \"\\e921\";\n  margin-left: -1em;\n  color: rgb(255, 215, 22);\n}\n.iconr-red-card .path7:before {\n  content: \"\\e922\";\n  margin-left: -1em;\n  color: rgb(255, 215, 22);\n}\n.iconr-red-card .path8:before {\n  content: \"\\e923\";\n  margin-left: -1em;\n  color: rgb(208, 38, 38);\n}\n.iconr-red-card .path9:before {\n  content: \"\\e924\";\n  margin-left: -1em;\n  color: rgb(152, 55, 53);\n}\n.iconr-red-card .path10:before {\n  content: \"\\e925\";\n  margin-left: -1em;\n  color: rgb(184, 156, 20);\n}\n.iconr-red-card .path11:before {\n  content: \"\\e926\";\n  margin-left: -1em;\n  color: rgb(184, 156, 20);\n}\n.iconr-red-card .path12:before {\n  content: \"\\e927\";\n  margin-left: -1em;\n  color: rgb(152, 55, 53);\n}\n.iconr-celebrate .path1:before {\n  content: \"\\e928\";\n  color: rgb(253, 211, 3);\n}\n.iconr-celebrate .path2:before {\n  content: \"\\e929\";\n  margin-left: -1em;\n  color: rgb(0, 194, 86);\n}\n.iconr-celebrate .path3:before {\n  content: \"\\e92a\";\n  margin-left: -1em;\n  color: rgb(0, 194, 86);\n}\n.iconr-celebrate .path4:before {\n  content: \"\\e92b\";\n  margin-left: -1em;\n  color: rgb(248, 197, 1);\n}\n.iconr-celebrate .path5:before {\n  content: \"\\e92c\";\n  margin-left: -1em;\n  color: rgb(49, 137, 72);\n}\n.iconr-celebrate .path6:before {\n  content: \"\\e92d\";\n  margin-left: -1em;\n  color: rgb(248, 197, 1);\n}\n.iconr-celebrate .path7:before {\n  content: \"\\e92e\";\n  margin-left: -1em;\n  color: rgb(0, 194, 86);\n}\n.iconr-celebrate .path8:before {\n  content: \"\\e92f\";\n  margin-left: -1em;\n  color: rgb(253, 211, 3);\n}\n.iconr-celebrate .path9:before {\n  content: \"\\e930\";\n  margin-left: -1em;\n  color: rgb(49, 137, 72);\n}\n.iconr-celebrate .path10:before {\n  content: \"\\e931\";\n  margin-left: -1em;\n  color: rgb(49, 137, 72);\n}\n.iconr-celebrate .path11:before {\n  content: \"\\e932\";\n  margin-left: -1em;\n  color: rgb(2, 86, 162);\n}\n.iconr-celebrate .path12:before {\n  content: \"\\e933\";\n  margin-left: -1em;\n  color: none;\n}\n.iconr-celebrate .path13:before {\n  content: \"\\e934\";\n  margin-left: -1em;\n  color: none;\n}\n.iconr-celebrate .path14:before {\n  content: \"\\e935\";\n  margin-left: -1em;\n  color: none;\n}\n.iconr-support .path1:before {\n  content: \"\\e936\";\n  color: rgb(241, 228, 63);\n}\n.iconr-support .path2:before {\n  content: \"\\e937\";\n  margin-left: -1em;\n  color: rgb(241, 228, 63);\n  opacity: 0.2;\n}\n.iconr-support .path3:before {\n  content: \"\\e938\";\n  margin-left: -1em;\n  color: rgb(184, 156, 20);\n  opacity: 0.2;\n}\n.iconr-support .path4:before {\n  content: \"\\e939\";\n  margin-left: -1em;\n  color: rgb(184, 156, 20);\n  opacity: 0.2;\n}\n.iconr-support .path5:before {\n  content: \"\\e93a\";\n  margin-left: -1em;\n  color: rgb(184, 156, 20);\n  opacity: 0.2;\n}\n.iconr-support .path6:before {\n  content: \"\\e93b\";\n  margin-left: -1em;\n  color: rgb(184, 156, 20);\n  opacity: 0.2;\n}\n.iconr-support .path7:before {\n  content: \"\\e93c\";\n  margin-left: -1em;\n  color: rgb(255, 215, 22);\n  opacity: 0.5;\n}\n.iconr-support .path8:before {\n  content: \"\\e93d\";\n  margin-left: -1em;\n  color: rgb(184, 156, 20);\n  opacity: 0.2;\n}\n.iconr-sad .path1:before {\n  content: \"\\e93e\";\n  color: rgb(241, 228, 63);\n}\n.iconr-sad .path2:before {\n  content: \"\\e93f\";\n  margin-left: -1em;\n  color: rgb(241, 228, 63);\n  opacity: 0.2;\n}\n.iconr-sad .path3:before {\n  content: \"\\e940\";\n  margin-left: -1em;\n  color: rgb(241, 228, 63);\n  opacity: 0.2;\n}\n.iconr-sad .path4:before {\n  content: \"\\e941\";\n  margin-left: -1em;\n  color: rgb(241, 228, 63);\n  opacity: 0.3;\n}\n.iconr-sad .path5:before {\n  content: \"\\e942\";\n  margin-left: -1em;\n  color: rgb(77, 84, 81);\n}\n.iconr-sad .path6:before {\n  content: \"\\e943\";\n  margin-left: -1em;\n  color: rgb(77, 84, 81);\n  opacity: 0.76;\n}\n.iconr-sad .path7:before {\n  content: \"\\e944\";\n  margin-left: -1em;\n  color: rgb(77, 84, 81);\n}\n.iconr-sad .path8:before {\n  content: \"\\e945\";\n  margin-left: -1em;\n  color: rgb(77, 84, 81);\n}\n.iconr-sad .path9:before {\n  content: \"\\e946\";\n  margin-left: -1em;\n  color: rgb(77, 84, 81);\n}\n.iconr-sad .path10:before {\n  content: \"\\e947\";\n  margin-left: -1em;\n  color: rgb(77, 84, 81);\n}\n.iconr-sad .path11:before {\n  content: \"\\e948\";\n  margin-left: -1em;\n  color: rgb(111, 203, 217);\n}\n.iconr-sad .path12:before {\n  content: \"\\e949\";\n  margin-left: -1em;\n  color: rgb(77, 84, 81);\n}\n.iconr-sad .path13:before {\n  content: \"\\e94a\";\n  margin-left: -1em;\n  color: rgb(77, 84, 81);\n}\n.iconr-sad .path14:before {\n  content: \"\\e94b\";\n  margin-left: -1em;\n  color: rgb(111, 203, 217);\n}\n.iconr-funny .path1:before {\n  content: \"\\e94c\";\n  color: rgb(241, 228, 63);\n}\n.iconr-funny .path2:before {\n  content: \"\\e94d\";\n  margin-left: -1em;\n  color: rgb(241, 228, 63);\n  opacity: 0.2;\n}\n.iconr-funny .path3:before {\n  content: \"\\e94e\";\n  margin-left: -1em;\n  color: rgb(241, 228, 63);\n  opacity: 0.2;\n}\n.iconr-funny .path4:before {\n  content: \"\\e94f\";\n  margin-left: -1em;\n  color: rgb(241, 228, 63);\n  opacity: 0.3;\n}\n.iconr-funny .path5:before {\n  content: \"\\e950\";\n  margin-left: -1em;\n  color: rgb(77, 84, 81);\n}\n.iconr-funny .path6:before {\n  content: \"\\e951\";\n  margin-left: -1em;\n  color: none;\n}\n.iconr-funny .path7:before {\n  content: \"\\e952\";\n  margin-left: -1em;\n  color: none;\n}\n.iconr-funny .path8:before {\n  content: \"\\e953\";\n  margin-left: -1em;\n  color: rgb(255, 255, 255);\n}\n.iconr-funny .path9:before {\n  content: \"\\e954\";\n  margin-left: -1em;\n  color: rgb(77, 84, 81);\n}\n.iconr-funny .path10:before {\n  content: \"\\e955\";\n  margin-left: -1em;\n  color: rgb(77, 84, 81);\n}\n.iconr-funny .path11:before {\n  content: \"\\e956\";\n  margin-left: -1em;\n  color: rgb(111, 203, 217);\n}\n.iconr-funny .path12:before {\n  content: \"\\e957\";\n  margin-left: -1em;\n  color: rgb(111, 203, 217);\n}\n.iconr-funny .path13:before {\n  content: \"\\e958\";\n  margin-left: -1em;\n  color: rgb(111, 203, 217);\n}\n.iconr-funny .path14:before {\n  content: \"\\e959\";\n  margin-left: -1em;\n  color: rgb(111, 203, 217);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
